import { setup } from "web/entrypoints/common/setup";
import "./css-lyst-news";
import { lystNewsComponents } from "./lyst-news";

setup(lystNewsComponents);
